export { default as theme } from 'prism-themes/themes/prism-duotone-dark.css';
